import { MAIN_SITE_URL } from '@/utils/constants';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Clean%20modern%20shopping%20lifestyle%20scene%20with%20neatly%20arranged%20fashion%20items%20including%20sneakers%20hoodie%20and%20accessories%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20light%20streaming%20from%20a%20window%20creating%20gentle%20shadows%2C%20minimalist%20aesthetic%20with%20organic%20textures%2C%20peaceful%20and%20inviting%20atmosphere%2C%20editorial%20product%20photography%20style%20with%20warm%20neutral%20tones&width=1800&height=700&seq=cta-bg-2026&orientation=landscape"
          alt="Explore Sugargoo Spreadsheet products and shopping resources"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/35 via-black/25 to-black/35"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          Ready to Discover Your Next Find?
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-xl mx-auto">
          Browse our comprehensive Sugargoo Spreadsheet categories or visit the main website to start shopping. Thousands of products are waiting to be discovered.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Sugargoo Spreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </span>
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-background-50 text-foreground-900 text-sm md:text-base font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}